module.exports = __webpack_public_path__ + "static/media/35@2x.4103d2d7.png";